import { reactive } from 'vue'

// 与 H5 相同：先读当前中心余额，有余额去大厅，余额为零去存款；未知余额不能当作零。
export function signInParticipationTarget(balance) {
  if (!['string', 'number'].includes(typeof balance) || String(balance).trim() === '' ||
    !/^\d+(?:\.\d+)?$/.test(String(balance).trim()) || !Number.isFinite(Number(balance))) {
    throw new Error('余额暂未查询到，请重试')
  }
  return Number(balance) > 0 ? '/' : '/mine/finance/deposit'
}

export function createSignInParticipationNavigation({ readBalance, isActive, getIdentity, navigate, notify }) {
  const state = reactive({ busy: '' })
  let sequence = 0
  async function go(source = 'primary') {
    if (state.busy || !isActive()) return
    const version = ++sequence, identity = getIdentity()
    const current = () => version === sequence && isActive() && identity === getIdentity()
    state.busy = source === 'qualification' ? 'entry:qualification' : 'entry:primary'
    try {
      const balance = await readBalance()
      if (current()) await navigate(signInParticipationTarget(balance))
    } catch (error) {
      if (current()) notify(error?.message || '暂时无法跳转，请重试', 'error')
    } finally { if (version === sequence) state.busy = '' }
  }
  function cancel() { ++sequence; state.busy = '' }
  return { state, go, cancel }
}
